import { Grid, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";
import EnumChangeName from "../common/EnumChangeName";

const TabPanel2 = ({ data, editVehicle }: any) => {
  const { t } = useTranslation(["operation"]);

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="motorizationCode"
          name="motorizationCode"
          label={t("vehicle.tabPanel2.motorizationCode")}
          value={data.motorizationCode}
        />
        <TextField
          fullWidth
          disabled
          id="motorizationDescr"
          name="motorizationDescr"
          label={t("vehicle.tabPanel2.motorizationDescr")}
          value={data.motorizationDescr}
        />
        <DatePicker
          label={t("vehicle.tabPanel2.registrationDate")}
          disabled
          inputFormat="DD-MM-YYYY"
          value={!!data.registrationDate ? data.registrationDate : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="distance"
          name="distance"
          label={t("vehicle.tabPanel2.distance")}
          value={data.distance}
        />
        <TextField
          fullWidth
          disabled
          id="fiscalHorsepower"
          name="fiscalHorsepower"
          label={t("vehicle.tabPanel2.fiscalHorsepower")}
          value={data.fiscalHorsepower}
        />
        <TextField
          fullWidth
          disabled
          id="horsepower"
          name="horsepower"
          label={t("vehicle.tabPanel2.horsepower")}
          value={data.horsepower}
        />
        <TextField
          fullWidth
          disabled
          id="kw"
          name="kw"
          label={t("vehicle.tabPanel2.kw")}
          value={data.kw}
        />
        <TextField
          fullWidth
          disabled
          id="enginePowerCode"
          name="enginePowerCode"
          label={t("vehicle.tabPanel2.enginePowerCode")}
          value={data.enginePowerCode}
        />
        <TextField
          fullWidth
          disabled
          id="enginePowerDescr"
          name="enginePowerDescr"
          label={t("vehicle.tabPanel2.enginePowerDescr")}
          value={data.enginePowerDescr}
        />
        <TextField
          fullWidth
          disabled
          id="tractionType"
          name="tractionType"
          label={t("vehicle.tabPanel2.tractionType")}
          value={data.tractionType}
        />
        <TextField
          fullWidth
          disabled
          id="tractionTypeDescr"
          name="tractionTypeDescr"
          label={t("vehicle.tabPanel2.tractionTypeDescr")}
          value={data.tractionTypeDescr}
        />
        <TextField
          fullWidth
          disabled
          id="doorsNumber"
          name="doorsNumber"
          label={t("vehicle.tabPanel2.doorsNumber")}
          value={data.doorsNumber}
        />
        <TextField
          fullWidth
          disabled
          id="kms"
          name="kms"
          label={t("vehicle.tabPanel2.kms")}
          value={data.kms}
        />

        {/* <TextField
          fullWidth
          disabled
          id="physicalLocationDescription"
          name="physicalLocationDescription"
          label={t("vehicle.tabPanel2.physicalLocationDescription")}
          value={data.physicalLocationDescription}
        /> */}
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="currentTermicTankFilling"
          name="currentTermicTankFilling"
          label={t("vehicle.currentTermicTankFilling")}
          value={
            data.currentTermicTankFilling !== undefined
              ? data.currentTermicTankFilling
              : ""
          }
        />
        <TextField
          fullWidth
          disabled
          id="currentElectricTankFilling"
          name="currentElectricTankFilling"
          label={t("vehicle.currentElectricTankFilling")}
          value={
            data.currentElectricTankFilling !== undefined
              ? data.currentElectricTankFilling
              : ""
          }
        />
        <TextField
          fullWidth
          disabled
          id="termicTankCapacity"
          name="termicTankCapacity"
          label={t("vehicle.tabPanel2.termicTankCapacity")}
          value={data.termicTankCapacity.toFixed(1)}
        />
        <TextField
          fullWidth
          disabled
          id="electricTankCapacity"
          name="electricTankCapacity"
          label={t("vehicle.tabPanel2.electricTankCapacity")}
          value={data.electricTankCapacity.toFixed(1)}
        />
        <TextField
          fullWidth
          disabled
          id="trunkCapacity"
          name="trunkCapacity"
          label={t("vehicle.tabPanel2.trunkCapacity")}
          value={data.trunkCapacity.toFixed(1)}
        />
        <TextField
          fullWidth
          id="keyless"
          name="keyless"
          label={t("vehicle.tabPanel1.keyless")}
          disabled
          value={
            editVehicle.keyless
              ? t("internOptionSelectName.yes")
              : t("internOptionSelectName.no")
          }
        ></TextField>
        <TextField
          fullWidth
          id="connected"
          name="connected"
          label={t("vehicle.tabPanel1.connected")}
          disabled
          value={
            editVehicle.connected
              ? t("internOptionSelectName.yes")
              : t("internOptionSelectName.no")
          }
        ></TextField>

        <TextField
          fullWidth
          disabled
          id="checkoutLastLocationDesc"
          name="checkoutLastLocationType"
          label={t("vehicle.tabPanel2.checkoutLastLocationDescr")}
          value={data.checkoutLastLocationDescription}
        />
        <TextField
          fullWidth
          disabled
          id="checkoutLastLocationType"
          name="checkoutLastLocationType"
          label={t("vehicle.tabPanel2.checkoutLastLocationType")}
          value={EnumChangeName().locationType(data.checkoutLastLocationType)}
        />
        <TextField
          fullWidth
          disabled
          id="checkoutLastLocation"
          name="checkoutLastLocation"
          label={t("vehicle.tabPanel2.checkoutLastLocation")}
          value={data.checkoutLastLocationId}
        />
        <TextField
          fullWidth
          disabled
          id="checkinLastLocationDescription"
          name="checkinLastLocationDescription"
          label={t("vehicle.tabPanel2.checkinLastLocationDescription")}
          value={data.checkinLastLocationDescription}
        />
        <TextField
          fullWidth
          disabled
          id="checkinLastLocationType"
          name="checkinLastLocationType"
          label={t("vehicle.tabPanel2.checkinLastLocationType")}
          value={EnumChangeName().locationType(data.checkinLastLocationType)}
        />
        <TextField
          fullWidth
          disabled
          id="chekinLastLocationSapId"
          name="chekinLastLocationSapId"
          label={t("vehicle.tabPanel2.checkinLastLocationSapId")}
          value={data.checkinLastLocationId}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          fullWidth
          disabled
          id="segmentCode"
          name="segmentCode"
          label={t("vehicle.tabPanel2.segmentCode")}
          value={data.commercialSegment}
        />
        <TextField
          fullWidth
          disabled
          id="commercialCategoryCode"
          name="commercialCategoryCode"
          label={t("vehicle.tabPanel2.commercialCategoryCode")}
          value={data.commercialCategoryCode}
        />
        <TextField
          fullWidth
          disabled
          id="commercialCategoryDescr"
          name="commercialCategoryDescr"
          label={t("vehicle.tabPanel2.commercialCategoryDescr")}
          value={data.commercialCategoryDescr}
        />
        <TextField
          fullWidth
          disabled
          id="carCompanyDescr"
          name="carCompanyDescr"
          label={t("vehicle.tabPanel2.carCompanyDescr")}
          value={data.carCompany.descr}
        />
        <TextField
          fullWidth
          disabled
          id="carCompanyCode"
          name="carCompanyCode"
          label={t("vehicle.tabPanel2.carCompanyCode")}
          value={data.carCompany.code}
        />
        <TextField
          fullWidth
          disabled
          id="carIdentifier"
          name="carIdentifier"
          label={t("vehicle.tabPanel2.carIdentifier")}
          value={data.carIdentifier}
        />
        <TextField
          fullWidth
          disabled
          id="chargesNationalTax"
          name="chargesNationalTax"
          label={t("vehicle.tabPanel2.chargesNationalTax")}
          value={data.chargesNationalTax}
        />
        <TextField
          fullWidth
          disabled
          id="hybridTypeCode"
          name="hybridTypeCode"
          label={t("vehicle.tabPanel2.hybridTypeCode")}
          value={data.hybridTypeCode}
        />
        <TextField
          fullWidth
          disabled
          id="hybridTypeDescr"
          name="hybridTypeDescr"
          label={t("vehicle.tabPanel2.hybridTypeDescr")}
          value={data.hybridTypeDescr}
        />
        <TextField
          fullWidth
          disabled
          id="scenarioCode"
          name="scenarioCode"
          label={t("vehicle.tabPanel2.scenarioCode")}
          value={data.scenarioCode}
        />
        <TextField
          fullWidth
          disabled
          id="scenarioDescr"
          name="scenarioDescr"
          label={t("vehicle.tabPanel2.scenarioDescr")}
          value={data.scenarioDescr}
        />

        <DatePicker
          label={t("vehicle.tabPanel2.checkinLastDate")}
          disabled
          inputFormat="DD-MM-YYYY HH:mm"
          value={!!data.checkinLastDatetime ? data.checkinLastDatetime : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />

        <TextField
          fullWidth
          disabled
          id="physicalLocationDescription"
          name="physicalLocationDescription"
          label={t("vehicle.tabPanel2.physicalLocationDescription")}
          value={data.physicalLocationDescription}
        />
      </Grid>
      <Grid item xs={3}>
        {/* <TextField
          fullWidth
          disabled
          id="checkinLastLocationId"
          name="checkinLastLocationId"
          label={t("vehicle.tabPanel2.checkinLastLocationDescription")}
          value={data.checkinLastLocationDescription}
        /> */}
        <DatePicker
          label={t("vehicle.tabPanel2.checkoutLastDate")}
          disabled
          inputFormat="DD-MM-YYYY HH:mm"
          value={!!data.checkoutLastDatetime ? data.checkoutLastDatetime : null}
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="emissionCo2"
          name="emissionCo2"
          label={t("vehicle.tabPanel2.emissionCo2")}
          value={data.emissionCo2}
        />

        <TextField
          fullWidth
          disabled
          id="checkinEstimatedLocationDescr"
          name="checkinEstimatedLocationDescr"
          label={t("vehicle.tabPanel2.checkinEstimatedLocationDescr")}
          value={data.checkinEstimatedLocationDescription}
        />
        <TextField
          fullWidth
          disabled
          id="checkinEstimatedLocationType"
          name="checkinEstimatedLocationType"
          label={t("vehicle.tabPanel2.checkinEstimatedLocationType")}
          value={EnumChangeName().locationType(
            data.checkinEstimatedLocationType
          )}
        />
        <TextField
          fullWidth
          disabled
          id="checkinEstimatedLocationId"
          name="checkinEstimatedLocationId"
          label={t("vehicle.tabPanel2.checkinEstimatedLocationId")}
          value={data.checkinEstimatedLocationId}
        />
        <TextField
          fullWidth
          disabled
          id="amps"
          name="amps"
          label={t("vehicle.tabPanel2.amps")}
          value={data.amps}
        />
        <TextField
          fullWidth
          disabled
          id="voltage"
          name="voltage"
          label={t("vehicle.tabPanel2.voltage")}
          value={data.voltage}
        />
        <TextField
          fullWidth
          disabled
          id="measureStandard"
          name="measureStandard"
          label={t("vehicle.tabPanel2.measureStandard")}
          value={data.measureStandard}
        />

        <DatePicker
          label={t("vehicle.tabPanel2.checkinEstimatedDate")}
          disabled
          inputFormat="DD-MM-YYYY HH:mm"
          value={
            !!data.checkinEstimatedDatetime
              ? data.checkinEstimatedDatetime
              : null
          }
          onChange={() => ""}
          renderInput={(params) => <TextField fullWidth {...params} />}
        />
        <TextField
          fullWidth
          disabled
          id="referenceLocationDescription"
          name="referenceLocationDescription"
          label={t("vehicle.tabPanel2.referenceLocationDescription")}
          value={data.referenceLocationDescription}
        />
        <TextField
          fullWidth
          disabled
          id="referenceLocationType"
          name="referenceLocationType"
          label={t("vehicle.tabPanel2.referenceLocationType")}
          value={EnumChangeName().locationType(data.referenceLocationType)}
        />
        <TextField
          fullWidth
          disabled
          id="physicalLocationType"
          name="physicalLocationType"
          label={t("vehicle.tabPanel2.physicalLocationType")}
          value={EnumChangeName().locationType(data.physicalLocationType)}
        />
      </Grid>
    </Grid>
  );
};
export default TabPanel2;
